/**
 * @fileoverview LogInventarioMaterialesRepository - Repository for log_inventario_materiales collection
 */

import { DataRepository } from './base/DataRepository';
import type {
  LogInventarioMateriales,
  CreateLogInventarioMaterialesData,
  UpdateLogInventarioMaterialesData,
} from '../types/collections/LogInventarioMateriales';
import type { QueryOptions } from '../types/common/PocketBaseTypes';

/**
 * Repository for managing LogInventarioMateriales records
 * Extends DataRepository with LogInventarioMateriales-specific methods
 */
export class LogInventarioMaterialesRepository extends DataRepository<LogInventarioMateriales> {
  constructor() {
    super('log_inventario_materiales');
  }

  /**
   * Get logs with usuario expanded
   * @param page Page number (1-based)
   * @param pageSize Number of records per page
   * @param options Additional query options
   * @returns Paginated result of logs with usuario expanded
   */
  async getLogsWithUsuario(
    page: number = 1,
    pageSize: number = 10,
    options: QueryOptions = {}
  ) {
    const queryOptions: QueryOptions = {
      expand: 'usuario',
      sort: '-created',
      ...options,
    };

    return this.getList(page, pageSize, queryOptions);
  }

  /**
   * Get ingresos (entries) with pagination
   * @param page Page number (1-based)
   * @param pageSize Number of records per page
   * @param options Additional query options
   * @returns Paginated result of ingreso logs
   */
  async getIngresos(
    page: number = 1,
    pageSize: number = 10,
    options: QueryOptions = {}
  ) {
    const queryOptions: QueryOptions = {
      filter: 'ingreso = true',
      sort: '-created',
      expand: 'usuario',
      ...options,
    };

    return this.getList(page, pageSize, queryOptions);
  }

  /**
   * Get egresos (exits) with pagination
   * @param page Page number (1-based)
   * @param pageSize Number of records per page
   * @param options Additional query options
   * @returns Paginated result of egreso logs
   */
  async getEgresos(
    page: number = 1,
    pageSize: number = 10,
    options: QueryOptions = {}
  ) {
    const queryOptions: QueryOptions = {
      filter: 'ingreso = false',
      sort: '-created',
      expand: 'usuario',
      ...options,
    };

    return this.getList(page, pageSize, queryOptions);
  }
}
